var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { COR_TEXTO } from '../../nps.constants';
export var DicaStyled = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 16px 0 0;\n  font-size: 14px;\n  line-height: 18px;\n  color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 16px 0 0;\n  font-size: 14px;\n  line-height: 18px;\n  color: ", ";\n"])), COR_TEXTO);
var templateObject_1;
